module.exports = __webpack_public_path__ + "static/img/13.77bb74c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/4/zh/13.png
// module id = 39x9
// module chunks = 0